import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { StringParam, useQueryParam } from "use-query-params";
import { authenticateUsingJWT } from "../Store/Actions";

const useAuthenticateJWT = () => {
  const dispatch = useDispatch();
  const [isJWTPresent, setIsJWTPresent] = useState(true);
  const [jwt_token, setJwtToken] = useQueryParam("jwt_token", StringParam);

  useEffect(() => {
    if (jwt_token) {
      authenticateUsingJWT(dispatch, jwt_token, () => {
        setJwtToken(null);
      });
    } else {
      setIsJWTPresent(false);
    }
  }, [jwt_token, dispatch, setJwtToken]);

  return { isJWTPresent };
};

export default useAuthenticateJWT;
